import { BONDS_ACTIONS, BONDS_NO_FILTER_ACTIONS, FULLTEXT_ACTIONS_INBONDS, GET_ALLBONDS_ACTIONS, BONDS_SEARCH_CREATE_ACTIONS, SEARCHFILTER_RENAME_ACTIONS, BONDS_SEARCH_FILTER_DETAIL_ACTIONS, FOLLOW_BOND_ACTION, BONDS_SEARCH_FILTER_LIST_ACTIONS, BONDS_POSITION_DETAIL_ACTIONS, BONDS_POSITION_CREATE_ACTIONS, BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS, BONDS_POSITION_PRICEBYDATE_ACTIONS, FULLTEXT_ACTIONS, GET_CLIENT_IP, GET_ISSUER_LIST_BY_FIRST_LETTER, GET_ISSUER_FIRST_LETTER_LIST, GET_ISSUER_LIST_BY_CHAR_ACTIONS, GET_ISSUER_HISTORY }  from "../../actionType/bonds";

const intialState = {
    bondsData: {},
    isBoandsLoader: false,
    AllbondsData: [],
    isAllbondsDataLoader: false,
    bondsFulltext: [],
    bondsFulltextHandle: {},
    trigger: false,
    isBoandsFullTextHandle: false,
    searchCreateData: {},
    isSearchCreateLoader: false,
    renameFilterData: {},
    isRenameFilterLoader: false,
    isSearchListLoader: false,
    isSearchDetailListLoader: false,
    followBond: {},
    isFollowBondLoader: false,
    bondCreatePositionData: {},
    isCreateBondPositionLoader: false,
    searchFilterDetailData: [],
    bondPositionData: [],
    isBondPositionLoader: false,
    bondSearchFilterList: [],
    isbondSearchFilterListLoader: false,
    bondPortfolioList: [],
    isbondPortfolioListLoader: false,
    bondPriceByDate: [],
    isbondPriceByDateLoader: false,
    noFilterBonds: null ,
    isNoFilterBondsLoading: false,
    clientIp: "",
    isclientIpLoading: false,
    isIssueListLoader: false,
    issuerNameListData: [],
    isIssuerFirstletterListLoader: false,
    isIssuerFirstletterListData: [],
    isIssuerListByCharLoader: false,
    isIssuerListByCharData: {},
    isIssuerHistoryLoader: false,
    isIssuerHistoryData: [],
  };
export const bondsReducer = (state = intialState, { type, payload, trigger }: any) => {
    switch (type) {

        //get bonds data
        case BONDS_ACTIONS.GET_BONDS:
          return { ...state, bondsData: payload, isBoandsLoader: false };
        case BONDS_ACTIONS.GET_BONDS_REQUEST:
          return { ...state, bondsData: payload, isBoandsLoader: true };
        case BONDS_ACTIONS.GET_BONDS_ERROR:
          // console.log("GET_BONDS_ERROR");
          return { ...state, bondsData: payload, isBoandsLoader: false };
    
        //get all bonds data without pagination
        case GET_ALLBONDS_ACTIONS.GET_ALLBONDS_ACTIONS_REQUEST:
    
          return { ...state, AllbondsData: payload, isAllbondsDataLoader: false };
        case GET_ALLBONDS_ACTIONS.GET_ALLBONDS_ACTIONS_RESPONSE:
          return { ...state, AllbondsData: payload, isAllbondsDataLoader: true };
    
        case GET_ALLBONDS_ACTIONS.GET_ALLBONDS_ACTIONS_ERROR:
          return { ...state, AllbondsData: payload, isAllbondsDataLoader: false };
    
        //get no filter bonds data
        case BONDS_NO_FILTER_ACTIONS.GET_BONDS_NO_FILTER_REQUEST:
          return { ...state, isNoFilterBondsLoading: true };
        case BONDS_NO_FILTER_ACTIONS.GET_BONDS_NO_FILTER:
          return { ...state, noFilterBonds: payload, isNoFilterBondsLoading: false };
        case BONDS_NO_FILTER_ACTIONS.GET_BONDS_NO_FILTER_ERROR:
          return { ...state, noFilterBonds: payload, isNoFilterBondsLoading: false };
    
    
        //FULLTEXT_ACTIONS
        case FULLTEXT_ACTIONS.FULLTEXT_GET_RESPONSE:
          return { ...state, bondsFulltext: payload, isBoandsFullTextLoader: false };
        case FULLTEXT_ACTIONS.FULLTEXT_REQUEST:
          return { ...state, bondsFulltext: payload, isBoandsFullTextLoader: true };
    
        case FULLTEXT_ACTIONS.FULLTEXT_ERROR:
          // console.log("GET_BONDS_ERROR");
          return { ...state, bondsFulltext: payload, isBoandsFullTextLoader: false };
    
        //FULLTEXT_ACTION_INBONDS
        case FULLTEXT_ACTIONS_INBONDS.FULLTEXT_ACTIONS_INBONDS_REQUEST:
          return { ...state, isBoandsFullTextHandle: true, trigger: trigger };
        case FULLTEXT_ACTIONS_INBONDS.FULLTEXT_ACTIONS_INBONDS_RESPONSE:
          return { ...state, bondsFulltextHandle: payload, isBoandsFullTextHandle: false, trigger: trigger };
    
    
        // BONDS_SEARCH_CREATE_ACTIONS
        case BONDS_SEARCH_CREATE_ACTIONS.BONDS_SEARCH_CREATE_REQUEST:
          return { ...state, isSearchCreateLoader: false };
        case BONDS_SEARCH_CREATE_ACTIONS.BONDS_SEARCH_CREATE_RESPONSE:
          return {
            ...state,
            searchCreateData: payload,
            isSearchCreateLoader: true,
          };
        case BONDS_SEARCH_CREATE_ACTIONS.BONDS_SEARCH_CREATE_ERROR:
          return {
            ...state,
            searchCreateData: payload,
            isSearchCreateLoader: false,
          };
    
        // BONDS_SEARCH_CREATE_ACTIONS
        case SEARCHFILTER_RENAME_ACTIONS.SEARCHFILTER_RENAME_REQUEST:
          return { ...state, isSearchCreateLoader: false };
        case SEARCHFILTER_RENAME_ACTIONS.SEARCHFILTER_RENAME_RESPONSE:
          return {
            ...state,
            renameFilterData: payload,
            isSearchCreateLoader: true,
          };
        case SEARCHFILTER_RENAME_ACTIONS.SEARCHFILTER_RENAME_ERROR:
          return {
            ...state,
            renameFilterData: payload,
            isSearchCreateLoader: false,
          };
        //FOLLOW BOND ACTION
        case FOLLOW_BOND_ACTION.FOLLOW_BOND__REQUEST:
          return { ...state, isFollowBondLoader: false };
        case FOLLOW_BOND_ACTION.FOLLOW_BOND:
          return {
            ...state,
            followBond: payload,
            isFollowBondLoader: true,
          };
        case FOLLOW_BOND_ACTION.FOLLOW_BOND__ERROR:
          return {
            ...state,
            followBond: payload,
            isFollowBondLoader: false,
          };
    
        // BONDS_SEARCH_FILTER_DETAIL_ACTIONS
    
        case BONDS_SEARCH_FILTER_DETAIL_ACTIONS.BONDS_SEARCH_FILTER_DETAIL_REQUEST:
          return { ...state, isSearchDetailListLoader: true };
        case BONDS_SEARCH_FILTER_DETAIL_ACTIONS.BONDS_SEARCH_FILTER_DETAIL_RESPONSE:
          return {
            ...state,
            searchFilterDetailData: payload,
            isSearchDetailListLoader: false,
          };
        case BONDS_SEARCH_FILTER_DETAIL_ACTIONS.BONDS_SEARCH_FILTER_DETAIL_ERROR:
          return {
            ...state,
            searchFilterDetailData: payload,
            isSearchDetailListLoader: false,
          };
        // BONDS_POSITION_DETAIL_ACTIONS
    
        case BONDS_POSITION_DETAIL_ACTIONS.BONDS_POSITION_DETAIL_REQUEST:
          return { ...state, isBondPositionLoader: false };
        case BONDS_POSITION_DETAIL_ACTIONS.BONDS_POSITION_DETAIL_RESPONSE:
          return {
            ...state,
            bondPositionData: payload,
            isBondPositionLoader: true,
          };
        case BONDS_POSITION_DETAIL_ACTIONS.BONDS_POSITION_DETAIL_ERROR:
          return {
            ...state,
            bondPositionData: payload,
            isBondPositionLoader: false,
          };
        // BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS
    
        case BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS.BONDS_POSITION_PORTFOLIO_DETAILS_REQUEST:
          return { ...state, isbondPortfolioListLoader: false };
        case BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS.BONDS_POSITION_PORTFOLIO_DETAILS_RESPONSE:
          return {
            ...state,
            bondPortfolioList: payload,
            isbondPortfolioListLoader: true,
          };
        case BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS.BONDS_POSITION_PORTFOLIO_DETAILS_ERROR:
          return {
            ...state,
            bondPortfolioList: payload,
            isbondPortfolioListLoader: false,
          };
        // BONDS_POSITION_PRICEBYDATE_ACTIONS
    
        case BONDS_POSITION_PRICEBYDATE_ACTIONS.BONDS_POSITION_PRICEBYDATE_ACTIONS_REQUEST:
          return { ...state, isbondPriceByDateLoader: false };
        case BONDS_POSITION_PRICEBYDATE_ACTIONS.BONDS_POSITION_PRICEBYDATE_ACTIONS_RESPONSE:
          return {
            ...state,
            bondPriceByDate: payload,
            isbondPriceByDateLoader: true,
          };
        case BONDS_POSITION_PRICEBYDATE_ACTIONS.BONDS_POSITION_PRICEBYDATE_ACTIONS_ERROR:
          return {
            ...state,
            bondPriceByDate: payload,
            isbondPriceByDateLoader: false,
          };
        // BONDS_POSITION_CREATE_ACTIONS
    
        case BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_REQUEST:
          return { ...state, isCreateBondPositionLoader: false };
        case BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_RESPONSE:
          return {
            ...state,
            bondCreatePositionData: payload,
            isCreateBondPositionLoader: true,
          };
        case BONDS_POSITION_CREATE_ACTIONS.BONDS_POSITION_CREATE_ERROR:
          return {
            ...state,
            bondCreatePositionData: payload,
            isCreateBondPositionLoader: false,
          };
    
        // BONDS_SEARCH_FILTER_LIST_ACTIONS
        case BONDS_SEARCH_FILTER_LIST_ACTIONS.BONDS_SEARCH_FILTER_LIST_REQUEST:
          return { ...state, isbondSearchFilterListLoader: false };
        case BONDS_SEARCH_FILTER_LIST_ACTIONS.BONDS_SEARCH_FILTER_LIST_RESPONSE:
          // console.log('BONDS_SEARCH_FILTER_LIST_ACTIONS------------>',payload)
          return {
            ...state,
            bondSearchFilterList: payload,
            isbondSearchFilterListLoader: true,
          };
        case BONDS_SEARCH_FILTER_LIST_ACTIONS.BONDS_SEARCH_FILTER_LIST_ERROR:
          return {
            ...state,
            bondSearchFilterList: payload,
            isbondSearchFilterListLoader: false,
          };
    
        // GET_ISSUER_FIRST_LETTER_LIST
        case GET_ISSUER_FIRST_LETTER_LIST.GET_ISSUER_FIRST_LETTER_LIST_REQUEST:
          return { ...state, isIssuerFirstletterListLoader: true };
        case GET_ISSUER_FIRST_LETTER_LIST.GET_ISSUER_FIRST_LETTER_LIST_RESPONSE:
          return {
            ...state,
            isIssuerFirstletterListData: payload,
            isIssuerFirstletterListLoader: false,
          };
        case GET_ISSUER_FIRST_LETTER_LIST.GET_ISSUER_FIRST_LETTER_LIST_ERROR:
          return {
            ...state,
            isIssuerFirstletterListData: payload,
            isIssuerFirstletterListLoader: false,
          };
    
        // GET_ISSUER_LIST_BY_CHAR_ACTIONS
        case GET_ISSUER_LIST_BY_CHAR_ACTIONS.GET_ISSUER_LIST_BY_CHAR_REQUEST:
          return { ...state, isIssuerListByCharLoader: false };
        case GET_ISSUER_LIST_BY_CHAR_ACTIONS.GET_ISSUER_LIST_BY_CHAR_RESPONSE:
          return {
            ...state,
            isIssuerListByCharData: payload,
            isIssuerListByCharLoader: true,
          };
        case GET_ISSUER_LIST_BY_CHAR_ACTIONS.GET_ISSUER_LIST_BY_CHAR_ERROR:
          return {
            ...state,
            isIssuerListByCharData: payload,
            isIssuerListByCharLoader: false,
          };
    
        // GET_ISSUER_LIST_BY_FIRST_LETTER
        case GET_ISSUER_LIST_BY_FIRST_LETTER.GET_ISSUER_LIST_BY_FIRST_LETTER_REQUEST:
          return { ...state, isIssueListLoader: false };
        case GET_ISSUER_LIST_BY_FIRST_LETTER.GET_ISSUER_LIST_BY_FIRST_LETTER_RESPONSE:
          return {
            ...state,
            issuerNameListData: payload,
            isIssueListLoader: true,
          };
        case GET_ISSUER_LIST_BY_FIRST_LETTER.GET_ISSUER_LIST_BY_FIRST_LETTER_ERROR:
          return {
            ...state,
            issuerNameListData: payload,
            isIssueListLoader: false,
          };
    
        // GET_ISSUER_HISTORY
        case GET_ISSUER_HISTORY.GET_ISSUER_HISTORY_REQUEST:
          return { ...state, isIssuerHistoryLoader: false };
        case GET_ISSUER_HISTORY.GET_ISSUER_HISTORY_RESPONSE:
          return {
            ...state,
            isIssuerHistoryData: payload,
            isIssuerHistoryLoader: true,
          };
        case GET_ISSUER_HISTORY.GET_ISSUER_HISTORY_ERROR:
          return {
            ...state,
            isIssuerHistoryData: payload,
            isIssuerHistoryLoader: false,
          };
    
        // Client ip address actions
        case GET_CLIENT_IP.GET_CLIENT_IP_REQUEST:
          return { ...state, isclientIpLoading: false };
        case GET_CLIENT_IP.GET_CLIENT_IP_RESPONSE:
          return {
            ...state,
            clientIp: payload,
            isclientIpLoading: true,
          };
        case GET_CLIENT_IP.GET_CLIENT_IP_ERROR:
          return {
            ...state,
            clientIp: payload,
            isclientIpLoading: false,
          };
    
        default:
          return state;
      }
};
